import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="text-lg font-heading font-bold mb-4">
                <Link to="/" className="hover:text-accent-300 transition-colors whitespace-nowrap">
                  虚空韩漫网
                </Link>
              </h4>
              <p className="text-sm text-background-200 leading-relaxed">
                正版韩漫大全，提供免费韩漫下拉式阅读。尊重版权，服务用户，打造最优质的韩漫阅读平台。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold mb-4 text-background-100">
                快速导航
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/" className="text-sm text-background-200 hover:text-accent-300 transition-colors whitespace-nowrap">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/all" className="text-sm text-background-200 hover:text-accent-300 transition-colors whitespace-nowrap">
                    漫画分类
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-200 hover:text-accent-300 transition-colors whitespace-nowrap">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold mb-4 text-background-100">
                热门分类
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/category/romance" className="text-sm text-background-200 hover:text-accent-300 transition-colors whitespace-nowrap">
                    恋爱韩漫
                  </Link>
                </li>
                <li>
                  <Link to="/category/fantasy" className="text-sm text-background-200 hover:text-accent-300 transition-colors whitespace-nowrap">
                    奇幻韩漫
                  </Link>
                </li>
                <li>
                  <Link to="/category/action" className="text-sm text-background-200 hover:text-accent-300 transition-colors whitespace-nowrap">
                    动作韩漫
                  </Link>
                </li>
                <li>
                  <Link to="/category/drama" className="text-sm text-background-200 hover:text-accent-300 transition-colors whitespace-nowrap">
                    剧情韩漫
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold mb-4 text-background-100">
                联系方式
              </h4>
              <ul className="flex flex-col gap-2">
                <li className="flex items-center gap-2 text-sm text-background-200">
                  <i className="ri-mail-line"></i>
                  <span>contact@szlzjsm.cn</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-200">
                  <i className="ri-customer-service-2-line"></i>
                  <span>在线客服：工作日 9:00-18:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/20 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-300">
              &copy; 2026 虚空韩漫网 szlzjsm.cn 版权所有 | 本站所有漫画均来自正版授权
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-300 hover:text-accent-300 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-background-300 hover:text-accent-300 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-300 hover:text-accent-300 transition-colors" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}